import { getDateFormat } from 'helpers/dates'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link as RouteLink } from 'react-router-dom'
import cn from 'classnames'
import moment from 'moment'
import { IconButton, Link, Tooltip } from '@material-ui/core'
import { formatMessage } from 'lib/intl'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import { fetchTableData } from 'reducers/myJobsDataViewer/action'
import * as AppRouter from 'constants/appRouting'
import ImageModal from 'components/common/Modals/ImageModal'
import { ReactComponent as CloseIcon } from 'assets/img/close-icon.svg'
import { JOBS_DATA_VIEWER_DEFAULT_FIELDS } from 'constants/index'
import licenseeDigitFormat from 'helpers/licenseeDigitFormat'
// import FadeInImage from 'components/common/FadeInImage'
import ReactImageAppear from 'react-image-appear'

class TableData extends ListFromTable {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
    }

    this.asyncData = true
    this.loadingData = props.tableLoader
    this.psfs.addPagination(
      1,
      props.profileDataViewerFilters.get('paginationLimit'),
    )
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.isPanelOpen !== this.props.isPanelOpen) {
      return false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  componentDidUpdate(prevProps) {
    const {
      isInitReady: prevInitReady,
      tableData: prevTableData,
      profileDataViewerFilters: prevProfileDataViewerFilters,
      activeRange: prevactiveRange,
    } = prevProps
    const {
      isInitReady,
      tableData,
      profileDataViewerFilters,
      activeRange,
    } = this.props
    const profileDataViewerFilterObj = profileDataViewerFilters.toJS()
    const prevProfileDataViewerFilterObj = prevProfileDataViewerFilters.toJS()
    const { start, end } = activeRange.toJS()
    const { start: prevStart, end: prevEnd } = prevactiveRange.toJS()
    const isFiltersChanged = Object.keys(profileDataViewerFilterObj).some(
      fieldName => {
        const currentFieldData = profileDataViewerFilterObj[fieldName]

        if (Array.isArray(currentFieldData) && fieldName !== 'dataFields') {
          return (
            currentFieldData.length !==
            prevProfileDataViewerFilterObj[fieldName].length
          )
        }

        return false
      },
    )

    if (isInitReady !== prevInitReady && isInitReady) {
      this.getData()
    }

    if (tableData !== prevTableData) {
      this.loadingData = false
    }

    if (
      isFiltersChanged ||
      start.format('YYYY-MM-DD') !== prevStart.format('YYYY-MM-DD') ||
      end.format('YYYY-MM-DD') !== prevEnd.format('YYYY-MM-DD')
    ) {
      this.loadingData = true
    }
  }

  reloadTableData(path) {
    this.psfs.init(path)
    this.getData()
  }

  handleModalChange = event => {
    event.preventDefault()
    const {
      target: { textContent },
    } = event

    this.setState({
      isModalOpen: !this.state.isModalOpen,
      currentImage: textContent,
    })
  }

  getTableProps() {
    const {
      tableData,
      profileDataViewerFilters,
      setMyJobsDataViewerFilter,
    } = this.props
    const { count } = tableData.toJS()
    const densePadding = profileDataViewerFilters.get('densePadding')
    const dataFields = this.getEnabledColumns()
    const enabledColumns = Object.values(dataFields).filter(Boolean)

    return {
      title: '',
      className: cn('jobs-viewer-table', {
        'vertical-scroll': count && count > 10,
        'horizontal-scroll': enabledColumns.length >= 4,
      }),
      showFilterBar: false,
      searching: false,
      creating: false,
      sorting: true,
      paging: true,
      dense: {
        enabled: true,
        state: densePadding,
        handler: () => {
          setMyJobsDataViewerFilter({
            densePadding: !densePadding,
          })
        },
      },
    }
  }

  getResultByType(result) {
    const { currentImage, isModalOpen } = this.state
    const { licensee } = this.props
    const { mimeType, uri, originalName } = result
    const isResultDateValid = moment(result, 'YYYY-MM-DD', true).isValid()

    if (typeof result === 'object' && originalName) {
      const isImage = result && mimeType && mimeType.includes('image')

      if (!isImage) {
        return (
          <Link
            href={uri}
            target="_blank"
            rel="noopener noreferrer"
            className="file-link"
            onClick={e => e.stopPropagation()}>
            {this.renderTextData(originalName)}
          </Link>
        )
      }

      return (
        <>
          {currentImage === originalName && (
            <ImageModal open={isModalOpen} onClose={this.handleModalChange}>
              <div className="modal-content">
                <div className="image-wrap">
                  {/* <FadeInImage */}
                  {/*  src={uri} */}
                  {/*  placeholderStyle={{ backgroundColor: 'transparent' }} */}
                  {/* /> */}
                  <ReactImageAppear
                    src={uri}
                    animationDuration="2s"
                    placeholderStyle={{ backgroundColor: 'transparent' }}
                  />
                </div>
                <div className="btn-wrap">
                  <IconButton onClick={this.handleModalChange}>
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            </ImageModal>
          )}
          <Link
            href={uri}
            rel="noopener noreferrer"
            className="file-link"
            onClick={e => this.handleModalChange(e)}>
            <Tooltip
              title={originalName}
              placement="top"
              classes={{
                tooltip: 'custom-tooltip',
              }}>
              <span className="cut-text">{originalName}</span>
            </Tooltip>
          </Link>
        </>
      )
    }
    if (Array.isArray(result)) {
      return this.renderTextData(result.join(', '))
    }
    if (isResultDateValid) {
      const dateDisplay = getDateFormat(licensee.usaDateFormat)

      return moment(result).format(dateDisplay)
    }

    return this.renderTextData(licenseeDigitFormat(result, licensee))
  }

  renderTextData = dataText => {
    const maxTextLimit = 18

    if (dataText.length > maxTextLimit) {
      const resultText = dataText.slice(0, maxTextLimit)

      return (
        <Tooltip
          title={dataText}
          placement="top"
          classes={{
            tooltip: 'custom-tooltip',
          }}>
          <span className="cut-text">{resultText}</span>
        </Tooltip>
      )
    }

    return dataText.toString()
  }

  getColumns() {
    const dataFields = this.getEnabledColumns()
    const columnWidth = 90 / Object.values(dataFields).filter(Boolean).length
    const columns = new ColumnCollection()
    const enabledColumns = this.getEnabledColumns()
    const {
      licensee: { usaDateFormat },
    } = this.props
    const dateDisplay = getDateFormat(usaDateFormat)

    columns.add(
      new Column('job', formatMessage('job'), {
        enabled: enabledColumns.job,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
        render: ({ job }) => this.renderTextData(job),
      }),
    )
    columns.add(
      new Column('job_task', formatMessage('task'), {
        enabled: enabledColumns.job_task,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
        render: ({ job_task }) => this.renderTextData(job_task),
      }),
    )
    columns.add(
      new Column('job_input', formatMessage('input'), {
        enabled: enabledColumns.job_input,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
        render: ({ job_input }) => this.renderTextData(job_input),
      }),
    )
    columns.add(
      new Column('date', formatMessage('input_date'), {
        enabled: enabledColumns.date,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
        render: row => moment(row.date).format(dateDisplay),
      }),
    )
    columns.add(
      new Column('job_number', formatMessage('job_id'), {
        enabled: enabledColumns.job_number,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
      }),
    )
    columns.add(
      new Column('locus_group', formatMessage('unit_group'), {
        enabled: enabledColumns.locus_group,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
      }),
    )
    columns.add(
      new Column('locus', formatMessage('unit'), {
        enabled: enabledColumns.locus,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
      }),
    )
    columns.add(
      new Column('job_input_type', formatMessage('input_type'), {
        enabled: enabledColumns.job_input_type,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
      }),
    )
    columns.add(
      new Column('result', formatMessage('input_value'), {
        enabled: enabledColumns.result,
        sorting: true,
        render: ({ result }) => this.getResultByType(result),
      }),
    )
    columns.add(
      new Column('last_edited_by', formatMessage('last_edited_by'), {
        enabled: enabledColumns.last_edited_by,
        sorting: true,
        styles: {
          maxWidth: `${columnWidth}%`,
        },
        render: ({ last_edited_by }) => this.renderTextData(last_edited_by),
      }),
    )

    return columns
  }

  getActions() {
    const actions = new ActionCollection()
    const { siteFilter } = this.props

    actions.add(
      new Action('arrow_forward', formatMessage('go_to_task'), null, {
        className: 'action-btn',
        component: RouteLink,
        callback: ({
          accessible,
          job,
          job_id,
          job_task_id,
          job_input_id,
          jobs_filters_preset,
          locus,
          locus_group,
        }) => {
          let queryString = `
                    site_id=${siteFilter}
                    &job=${job}
                    &job_id=${job_id}
                    &task_id=${job_task_id}
                    &input_id=${job_input_id}
                    &filter_preset=${jobs_filters_preset}
                `.replace(/\s/g, '')

          if (locus) {
            queryString += `&locus=${locus}`
          }

          if (locus_group) {
            queryString += `&locus_group=${locus_group}`
          }

          return {
            disabled: !accessible,
            to: {
              pathname: AppRouter.MY_JOBS,
              search: queryString,
            },
            target: '_blank',
          }
        },
      }),
    )

    return actions
  }

  onSizePerPageListEvent = limit => {
    const { setMyJobsDataViewerFilter } = this.props

    setMyJobsDataViewerFilter({
      paginationLimit: limit,
    })
  }

  getEnabledColumns = () => {
    const { dataFields } = this.props
    let arrDataFileds = dataFields.toArray()
    const defaultColumns = {
      job: true,
      job_input: true,
    }
    const enabledColumns = {
      ...defaultColumns,
      job_task: true,
      date: true,
      job_number: true,
      locus_group: true,
      locus: true,
      job_input_type: true,
      result: true,
      last_edited_by: true,
    }

    if (!arrDataFileds.length) {
      arrDataFileds = Object.keys(defaultColumns)
    }

    Object.keys(enabledColumns).forEach(key => {
      if (
        arrDataFileds.includes(key) ||
        JOBS_DATA_VIEWER_DEFAULT_FIELDS.includes(key)
      ) {
        enabledColumns[key] = true
      } else {
        enabledColumns[key] = false
      }
    })

    return enabledColumns
  }

  addPsfsFilters = psfs => {
    const {
      locusGroups,
      locuses,
      jobs,
      jobTasks,
      jobInputs,
      jobInputTypes,
    } = this.props.profileDataViewerFilters.toJS()
    const result = {
      job: jobs,
      job_task: jobTasks,
      job_input: jobInputs,
      job_input_type: jobInputTypes,
      locus_group: locusGroups,
      locus: locuses,
    }

    Object.keys(result).forEach(key => {
      psfs.clearFilter(key)

      let positiveIds
      let dataArr = result[key]

      if (key === 'job_input_type') {
        positiveIds = dataArr.filter(item => item && item !== '-1')
      } else {
        positiveIds = dataArr.filter(item => item > 0)
      }

      if (positiveIds.length) {
        dataArr = positiveIds
      } else {
        dataArr = []
      }

      if (dataArr.length) {
        psfs.addFilter(key, dataArr, 'in')
      }
    })
  }

  getData = () => {
    const { fetchTableData, siteFilter, activeRange } = this.props
    this.addPsfsFilters(this.psfs)

    fetchTableData({
      psfs: this.psfs,
      params: {
        site: siteFilter,
        from: activeRange.get('start').format('YYYY-MM-DD'),
        to: activeRange.get('end').format('YYYY-MM-DD'),
      },
    })
  }
}

export default connect(
  store => ({
    activeRange: store.getIn(['myJobsDataViewer', 'activeDateRange']),
    siteFilter: store.getIn(['profile', 'jobsDataViewerFilters', 'site']),
    dataFields: store.getIn(['profile', 'jobsDataViewerFilters', 'dataFields']),
    profileDataViewerFilters: store.getIn(['profile', 'jobsDataViewerFilters']),
    tableData: store.getIn(['myJobsDataViewer', 'tableData']),
    isInitReady: store.getIn(['myJobsDataViewer', 'isInitReady']),
    tableLoader: store.getIn(['myJobsDataViewer', 'isLoadTableData']),
    licensee: store.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    fetchTableData,
    setMyJobsDataViewerFilter,
  },
)(withRouter(TableData))
